import {
    CheckboxFilter,
    type FilterData,
    type FilterKey,
} from '@itinerary/ItineraryModuleTypes';
import {
    type DiningServiceView,
    type HotelSearchAmenityView,
    type HotelSearchHotelTypeView,
    type HotelSpecialOfferView,
} from '@clients/HotelApi';

export enum HotelFilters {
    Price = 'price',
    AccommodationTypes = 'accommodationTypes',
    Amenities = 'amenities',
    Labels = 'labels',
    Services = 'services',
    Stars = 'stars',
}

export class StarFilter extends CheckboxFilter {
    constructor() {
        super(
            'stars',
            [
                {
                    title: '5',
                    id: '5',
                },
                {
                    title: '4',
                    id: '4',
                },
                {
                    title: '3',
                    id: '3',
                },
                {
                    title: '2',
                    id: '2',
                },
                {
                    title: '1',
                    id: '1',
                },
                {
                    title: 'بدون ستاره',
                    id: '0',
                },
            ],
            'ستاره هتل'
        );
        this.component = 'StarFilter';
    }
}

export enum HotelSortBy {
    Sale = 'sale',
    HigherPrice = 'higherPrice',
    LowerPrice = 'lowerPrice',
    HigherScore = 'higherScore',
    MrbilitOffer = 'mrbilitOffer',
}

export type HotelSearchHotelTypeViewCumulated = HotelSearchHotelTypeView & {
    cumulatedIds: number[];
};

export interface HotelFilterData extends FilterData {
    maxPrice: number;
    minPrice: number;
    amenities: HotelSearchAmenityView[];
    accommodationTypes: HotelSearchHotelTypeViewCumulated[];
    serviceLevels: DiningServiceView[];
    specialOffers: HotelSpecialOfferView[];
}

export type HotelPriceObject = Record<
    string,
    {
        price: number;
        isFull: boolean;
    }
>;

export interface HotelFiltersData {
    key: FilterKey;
    meta: HotelFilterData;
}
